// App.js
import { Routes, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import Home from './page/Home';
import AdminPanel from './components/Forms/AdminPanel';
import Departamento from './components/Forms/Departamento';
import Municipios from './components/Forms/Municipios';
import RecursoSolar from './components/Forms/RecursoSolar';
import TipoPersona from './components/Forms/TipoPersona';
import TipoTecho from './components/Forms/TipoTecho';
import ValoresKw from './components/Forms/ValoresKw';
import PrecotizacionWizard from './components/Precotizacion/PrecotizacionWizard';
import About from './page/about';
import Systems from './page/Systems';
import SuccessCases from './page/SuccessCases'

function App() {
  return (

    <div className="min-h-screen bg-gray-100">
      <SnackbarProvider maxSnack={3}>

        <Routes>

          <Route path="/departamento" element={<Departamento />} />
          <Route path="/municipios" element={<Municipios />} />
          <Route path='/recursosolar' element={<RecursoSolar />} />
          <Route path='/tipopersona' element={<TipoPersona />} />
          <Route path='/tipotecho' element={<TipoTecho />} />
          <Route path='/valoreskw' element={<ValoresKw />} />
          <Route path='/precotizacion' element={<PrecotizacionWizard />} />

          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path='/Systems' element={<Systems />} />
          <Route path='/success-cases' element={<SuccessCases />} />

          {/* <Route path="/" element={<TesterApipost />} /> */}
          {/* <Route path="/" element={<AdminPanel />} /> */}
          {/* <Route path="/admin" element={<AdminPanel />} />  */}
        </Routes>
      </SnackbarProvider>

    </div>
  );
}

export default App;